"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

import { localStorage } from "./utils/local-storage";

export default function Index() {
  const router = useRouter();
  useEffect(() => {
    router.replace(localStorage?.getItem("lastPath") || "/home/");
  }, [router]);
  return null;
}
